export enum Pathnames {
  Board = '/b',
  ContextSizes = '/context/sizes',
  ContextSources = '/context',
  ContextSourcesByContextSourceId = '/context/[contextSourceId]',
  FavoriteItems = '/favorite-items',
  Library = '/l',
  MyUploads = '/my-uploads',
  People = '/people',
  RecentlyAdded = '/recently-added',
  RecentlyDeleted = '/recently-deleted',
  RecentlyModified = '/recently-modified',
  Search = '/all',
  UntaggedItems = '/untagged-items',
  UnusedItems = '/unused-items',
  Showcases = '/showcases',
  Skills = '/skills',
  Automations = '/automations',
  AutomationsByAutomationId = '/automations/[automationId]',
  AutomationsNew = '/automations/new',
  MyCanvases = '/canvases',
}
